// -------------------------------------
// Quantity Input (WooCommerce)
// -------------------------------------
(function($) {

  $(document).ready(function() {

    $(".woocommerce .quantity .input-group input.qty").addClass("plus-minus");

    $(".woocommerce .quantity").on("click", ".minus", function(e) {
      var $inputQty = $(this).closest(".input-group").find("input.qty");
      var val = parseInt($inputQty.val());
      var step = $inputQty.attr("step");
      step = "undefined" !== typeof(step) ? parseInt(step) : 1;
      if (val > 0) {
        $inputQty.val(val - step).change();
      }
    });

    $(".woocommerce .quantity").on("click", ".plus", function(e) {
      var $inputQty = $(this).closest(".input-group").find("input.qty");
      var val = parseInt($inputQty.val());
      var step = $inputQty.attr("step");
      step = "undefined" !== typeof(step) ? parseInt(step) : 1;
      $inputQty.val(val + step).change();
    });

  });

})(jQuery);